import momentTimezone from 'moment-timezone';

const timezones = momentTimezone.tz
  .names()
  .filter(zone => zone.startsWith('US/'));

const mappedTimezoneOptions = timezones.map(timezone => {
  return {
    value: timezone,
    label: timezone
  };
});

export const timezoneOptions = [...mappedTimezoneOptions];

export const viewTimezoneOptions = timezones.map(timezone => {
  return {
    value: timezone,
    text: timezone
  };
});



/** WEBPACK FOOTER **
 ** ./src/utils/timezones.js
 **/